import React from 'react';
import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { getLoanApplication, getCampaignFromEnvConfig, getLoanAmountBoundaries, getMarketCode, getFeatureToggle } from '../../../selectors';
import { submitCheckYourRate, displayFormErrorOnSubmit, updateFormValue } from '../../../actions/loanApplicationActions';
import LoanPurposeFieldSet from '../LoanPurposeFieldSet/loanPurposeFieldSet';
import NameFieldSet from '../NameFieldSet/nameFieldSet';
import MailingAddressFieldSet from '../AddressFieldSet/mailingAddressFieldSet';
import HousingFieldSet from '../HousingFieldSet/housingFieldSet';
import EmploymentFieldSet from '../EmploymentFieldSet/employmentFieldSet';
import PersonalFieldSet from '../PersonalFieldSet/personalFieldSet';
import ContactFieldSet from '../ContactFieldSet/contactFieldSet';
import LoanAmountFieldSet from '../LoanAmountFieldSet/loanAmountFieldSet';
import { MarketCodes } from "../../../marketCodes";
import { pick, compose } from 'ramda';
import PropTypes from 'prop-types';
import '../applicationForm.scss';

export class CheckYourRateForm extends React.Component {

  renderFieldSets = () => {
    const { initialValues, currentValues, minAmount, maxAmount, updateFormValue } = this.props;
    const updateCheckYourRateFormValue = (key, value) => {
      updateFormValue('checkYourRate', key, value);
    };

    switch (initialValues.marketCode) {
    case MarketCodes.OPEN_MARKET:
      return [
        <LoanPurposeFieldSet key="LoanPurposeFieldSet" value={currentValues.loanPurpose} loanAmount={initialValues.loanAmount}/>,
        <NameFieldSet key="NameFieldSet" isReadOnly={false}/>,
        <MailingAddressFieldSet key="MailingAddressFieldSet"/>,
        <HousingFieldSet key="HousingFieldSet" />,
        <EmploymentFieldSet
          displayFullAppFields={false}
          initialValues={ initialValues }
          occupation={ currentValues.occupation }
          sourceOfIncome={ currentValues.sourceOfIncome }
          updateFormValue={updateCheckYourRateFormValue}
        />,
        <ContactFieldSet key="ContactFieldSet" displayFullAppFields={false} />,
        <PersonalFieldSet key="PersonalFieldSet" displayFullAppFields={false} />
      ];
    case MarketCodes.DIRECT_MAILER:
      return [
        <LoanAmountFieldSet key="LoanAmountFieldSet" minAmount={minAmount} maxAmount={maxAmount}/>,
        <HousingFieldSet key="HousingFieldSet" />,
        <EmploymentFieldSet
          displayFullAppFields={false}
          initialValues={ initialValues }
          occupation={ currentValues.occupation }
          sourceOfIncome={ currentValues.sourceOfIncome }
          updateFormValue={updateCheckYourRateFormValue}
        />,
        <ContactFieldSet key="ContactFieldSet" displayFullAppFields={false} />,
        <PersonalFieldSet key="PersonalFieldSet" displayFullAppFields={false} />
      ];
    case MarketCodes.BANK_MARKET:
      return [
        <LoanAmountFieldSet key="LoanAmountFieldSet" minAmount={minAmount} maxAmount={maxAmount}/>,
        <LoanPurposeFieldSet key="LoanPurposeFieldSet" value={currentValues.loanPurpose} loanAmount={currentValues.loanAmount}/>,
        <EmploymentFieldSet
          displayFullAppFields={false}
          initialValues={ initialValues }
          occupation={ currentValues.occupation }
          sourceOfIncome={ currentValues.sourceOfIncome }
          updateFormValue={ updateCheckYourRateFormValue }
        />,
        <HousingFieldSet key="HousingFieldSet" />
      ];
    default:
      return [];
    }
  };

  render() {
    const { submitCheckYourRate, displayFormErrorOnSubmit, throwOnNullCyrToggle, handleSubmit, submitting, submitSucceeded } = this.props;

    if (submitSucceeded) {
      return <Redirect push to="/apply/loan/select-offer"/>;
    }

    return (
      <form
        name="checkYourRate"
        autoComplete="off"
        noValidate="novalidate"
        className="check-your-rate-form application-form mt-4"
        onSubmit={compose(displayFormErrorOnSubmit, handleSubmit(data => submitCheckYourRate(data, throwOnNullCyrToggle)))}>
        {this.renderFieldSets()}
        <p>
          <button type="submit" disabled={submitting}>Continue</button>
        </p>
        <footer>
          <p>
            <i className="material-icons">thumb_up</i> Checking your rate won't affect your credit score.
          </p>
        </footer>
      </form>);
  }
}

CheckYourRateForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitSucceeded: PropTypes.bool.isRequired,
  submitFailed: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  minAmount: PropTypes.string,
  maxAmount: PropTypes.string,
  throwOnNullCyrToggle: PropTypes.bool
};

const selector = formValueSelector('checkYourRate');
const mapStateToProps = state => ({
  initialValues: {
    ...getLoanApplication(state),
    ...pick(['campaignId', 'cellId'], getCampaignFromEnvConfig(state)),
    marketCode: getMarketCode(state)
  },
  currentValues: {
    loanPurpose: selector(state, 'loanPurpose'),
    occupation: selector(state, 'occupation'),
    sourceOfIncome: selector(state, 'sourceOfIncome'),
    loanAmount: selector(state, 'loanAmount')
  },
  ...getLoanAmountBoundaries(state),
  throwOnNullCyrToggle: getFeatureToggle(state, "cl_throw_on_null_cyr")
});

const mapDispatchToProps = { submitCheckYourRate, displayFormErrorOnSubmit, updateFormValue };

export const CheckYourRateReduxForm = reduxForm({
  form: 'checkYourRate'
})(CheckYourRateForm);

export default connect(mapStateToProps, mapDispatchToProps)(CheckYourRateReduxForm);
